const attendance = {
    attendanceHeader: {
        admin: {
            mainHeading: 'Attendance Overview',
            description: 'Monitor attendance across the organization.'
        },
        employeeSelf: {
            mainHeading: 'My Attendance',
            description: 'View your attendance records and summary.'
        },
        supervisor:{
            mainHeading: 'Team Attendance',
            description: 'Track attendance and trends for your team.'
        }
    },

    upcomingLeavesText:{
        approvedLeave:'Leave approved',
        pendingLeave:'Leave requested',
    },

    attendanceStatHeaderText: {
        adminEmployee: {
            mainHeading: 'Attendance Insights for',
            description: 'Review admin-attendance-card details and performance metrics for this employee'
        },
        employeeSelf: {
            mainHeading: 'Attendance Stats',
            description: 'Keep track of your time, admin-attendance-card, and monthly progress'
        }
    },

    downloadActionPopover: {
        title: 'Download PDF',
        message: 'Proceed to download file ?'
    },

    employeeAttendanceCard: {
        checkInButtonText: 'Check In',
        checkOutButtonText: 'Check Out',
        checkoutPopover: {
            title: 'CheckOut',
            message: 'Are you sure you wanna checkout'
        }
    },

    downloadButtonText: 'Download',
    viewStatButtonText: 'View Stats',
    goBackButtonText: 'Go To Records'
}

export default attendance;
